import React from "react";

import { FormSectionElements } from "../../entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import NumericValueUtils from "../../utilities/NumericValueUtils";

interface Props {
  field: FormSectionElements;
  isEng: boolean;
}

const orderItemHtml = (isEng: boolean, itemInfo: any): React.JSX.Element => {
  return (
    <>
      <tr style={{ border: 0, backgroundColor: "#fff" }}>
        <th scope="row" style={{padding: "0.25rem 1rem 1.1875rem 1.5rem"}}>
          {itemInfo.itemDescription1}
        </th>
        <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
        <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
        <td className="ontario-table-cell--numeric" style={{fontWeight: 'bold', padding: "0rem 1rem 1.1875rem 1.5rem"}}>
          {itemInfo.itemAmount1}
        </td>
      </tr>
      <tr style={{ border: 0, backgroundColor: "#fff" }}>
        <td scope="row" style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}>
          {itemInfo.itemDescription2}
        </td>
        <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
        <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
        <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
      </tr>
    </>
  );
}

const orderItemsHtml = (isEng: boolean, orderInfo: any): React.JSX.Element[] => {
  if (!orderInfo?.orderItemLines?.length) {
    return ([
      <>
        <tr style={{ border: 0, backgroundColor: "#fff" }}>
          <th scope="row" style={{padding: "0.25rem 1rem 1.1875rem 1.5rem"}}>
          </th>
          <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
          <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
          <td className="ontario-table-cell--numeric" style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}>
          </td>
        </tr>
      </>
    ]);
  }

  const elements = [];
  orderInfo.orderItemLines.map((line) => {
    elements.push(orderItemHtml(isEng, line));
  })
  return elements;
}

const subTotalAmountHtml = (isEng: boolean, orderInfo: any): React.JSX.Element => {
  if (!orderInfo?.subTotalLine) {
    return (
      <>
        <tr style={{ border: 0, backgroundColor: "#fff" }}>
          <th scope="row" style={{padding: "0.25rem 1rem 1.1875rem 1.5rem"}}>
            {isEng ? 'Subtotal' : 'Sous-total'}
          </th>
          <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
          <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
          <td className="ontario-table-cell--numeric" style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}>
            {isEng ? NumericValueUtils.toAmountInEnglish(0) : NumericValueUtils.toAmountInFrench(0)}
          </td>
        </tr>
      </>
    );
  }

  return (
    <>
      <tr style={{ border: 0, backgroundColor: "#fff" }}>
        <th scope="row" style={{padding: "0.25rem 1rem 1.1875rem 1.5rem"}}>
          {orderInfo.subTotalLine.subTotalDescription}
        </th>
        <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
        <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
        <td className="ontario-table-cell--numeric" style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}>
          {orderInfo.subTotalLine.subTotalAmount}
        </td>
      </tr>
    </>
  );
}

const taxAmountHtml = (isEng: boolean, orderInfo: any): React.JSX.Element => {
  if (!orderInfo?.totalTaxLine) {
    return (
      <>
        <tr style={{ border: 0, backgroundColor: "#fff" }}>
          <th scope="row" style={{padding: "0.25rem 1rem 1.1875rem 1.5rem"}}>
            {isEng ? 'HST' : 'TVH'}
          </th>
          <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
          <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
          <td className="ontario-table-cell--numeric" style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}>
            {isEng ? NumericValueUtils.toAmountInEnglish(0) : NumericValueUtils.toAmountInFrench(0)}
          </td>
        </tr>
      </>
    );
  }

  return (
    <>
      <tr style={{ border: 0, backgroundColor: "#fff" }}>
        <th scope="row" style={{padding: "0.25rem 1rem 1.1875rem 1.5rem"}}>
          {orderInfo.totalTaxLine.taxDescription}
        </th>
        <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
        <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
        <td className="ontario-table-cell--numeric" style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}>
          {orderInfo.totalTaxLine.totalTaxAmount}
        </td>
      </tr>
    </>
  );
}

const totalAmountHtml = (isEng: boolean, orderInfo: any): React.JSX.Element => {
  if (!orderInfo?.totalAmountLine) {
    return (
      <>
        <tr style={{ border: 0, backgroundColor: "#fff" }}>
          <th scope="row" style={{padding: "0.25rem 1rem 1.1875rem 1.5rem"}}>
            {isEng ? 'Total' : 'Totale'}
          </th>
          <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
          <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
          <td className="ontario-table-cell--numeric" style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}>
            {isEng ? NumericValueUtils.toAmountInEnglish(0) :
              NumericValueUtils.toAmountInFrench(0)}
          </td>
        </tr>
      </>
    );
  }

  return (
    <>
      <tr style={{ border: 0, backgroundColor: "#fff" }}>
        <th scope="row" style={{padding: "0.25rem 1rem 1.1875rem 1.5rem"}}>
          {orderInfo.totalAmountLine.taxAmountDescription}
        </th>
        <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
        <td style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}></td>
        <td className="ontario-table-cell--numeric" style={{padding: "0rem 1rem 1.1875rem 1.5rem"}}>
          {orderInfo.totalAmountLine.totalAmount}
        </td>
      </tr>
    </>
  );
}

/**
 * A generic component to display the breakdown of the order and prices.
 * @param param0 
 * @returns 
 */
const OrderPriceBreakdownComponent = ({field, isEng}: Props) => {
  FormValidationUtils.runJavascript(field);
  const orderInfo = field.Value?.en && field.Value?.fr ? (isEng ? field.Value.en : field.Value.fr): field.Value; 

  return (
    <>
      <div className="ontario-table-container ontario-small-12 ontario-medium-12 ontario-large-12">
        <div className="ontario-table-scroll--wrapper">
          <div className="ontario-table-scroll--div"></div>
        </div>
        <div className="ontario-table-div">
          <table style={{width: '80%'}}>
            <caption>{isEng ? 'Items ordered and related fees' : 'Articles commandés et frais associés'}</caption>
            <tbody>
              {orderItemsHtml(isEng, orderInfo)}
              <tr style={{ borderTop: "solid", borderWidth: "0.1rem", borderColor: "#e1dfdd", backgroundColor:"#fff" }}></tr>
              {subTotalAmountHtml(isEng, orderInfo)}
              {taxAmountHtml(isEng, orderInfo)}
              {totalAmountHtml(isEng, orderInfo)}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default OrderPriceBreakdownComponent;